module.exports = "<div class=\"q-pill q-pill-table {%- pillClass %} q-boldest\"> <span>{%- utilization %}</span>% Utilization </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/standardPlatformFacilitySetupWizard/html/utilizationPillTemplate.html
// module id = 1433
// module chunks = 1